import store from '../../../store';

import Modal from '../../common/dialog/dialog.vue';

import { SYSTEM_BOUNDED_KEYS } from '../../system-hotkeys';

import transform from 'lodash/transform';

const OPTIONS = {
   showClose: false,
   showCancel: false,

   confirmText: 'Close',

   headerText: 'Hotkeys'
};

export default {
   name: 'KeyLegendDialog',
   store,
   components: { Modal },
   data() {
      return {
         opts  : { ...OPTIONS },
         keys  : transform(SYSTEM_BOUNDED_KEYS, _keyReducer, [])
      };
   }
};

function _keyReducer(memo, label, code) {
   const letter = String.fromCharCode(code);
   memo.push({ code, label, letter });
}
